/** Типова колірна схема — «Парламент» (світла, акцент парламентського синього), як у прототипі v4. */
export const DEFAULT_COLOR_SCHEME_ID = 'parliament';
